import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import {AnalyticsService} from "../../services/analytics.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";


/*Sentry.init({
    dsn: "https://80ed92b3d53545819f43caeba5722165@o1371022.ingest.sentry.io/6674896",
    integrations: [
        new Sentry.BrowserTracing({
            tracingOrigins: ["localhost", `https://${environment.domain}`],
            routingInstrumentation: Sentry.routingInstrumentation,
        }),
        new Sentry.Replay(),
    ],
    release: environment.version,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});*/


@NgModule({ declarations: [],
    exports: [], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule], providers: [
        AnalyticsService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class SharedModule {
}
